<div class="ap-selector" [class.ap-selector--single-option-value]="isSingleOptionValue()">
    <label class="ap-selector__wrapper" data-testid="wrapper">
        <span class="ap-selector__label" data-testid="label">{{ label() }}</span>
        <select
            class="ap-selector__select"
            (click)="clicked.emit()"
            (keydown)="keyDown($event)"
            (blur)="handleBlur()"
            [attr.disabled]="isDisabled ? isDisabled : null"
            [attr.aria-required]="isRequired ? isRequired : null"
            [attr.aria-invalid]="control ? control.invalid : null"
            [attr.aria-describedby]="control ? uniqueId + '-errors' : null"
            [attr.multiple]="selectionType() === 'multiple' ? true : null"
            aria-haspopup="dialog"
            data-testid="select"
        >
            <option
                hidden
                disabled
                value
                [attr.selected]="!selectedOptions() || selectedOptions().length === 0 ? 'true' : null"
                data-testid="empty-option"
            >
                {{ 'selectorSelect.empty.title' | apContent }} {{ 'selectorSelect.empty.text' | apContent }}
            </option>

            @for (option of options(); track i; let i = $index) {
                @if (option.subOptions) {
                    <optgroup [label]="option.title" data-testid="option-group">
                        @for (subOption of option.subOptions; track i; let i = $index) {
                            <option [value]="subOption" [attr.selected]="isSelected(subOption) ? 'true' : null" data-testid="option">
                                {{ subOption.title }} {{ subOption.text }}
                            </option>
                        }
                    </optgroup>
                } @else {
                    <option [value]="option" [attr.selected]="isSelected(option) ? 'true' : null" data-testid="option">
                        {{ option.title }} {{ option.text }}
                    </option>
                }
            }
        </select>
    </label>

    <div class="ap-selector__display" data-testid="display" aria-hidden="true" [attr.aria-disabled]="isDisabled ? isDisabled : null">
        @if (selectedOptions()?.length === 1 && selectedOptions()[0].icon) {
            <ap-icon
                class="ap-selector__selected-icon"
                [name]="selectedOptions()[0].icon"
                color="inherit"
                size="large"
                data-testid="display-icon"
            ></ap-icon>
        }
        <span class="ap-selector__display-body">
            <span class="ap-selector__title" data-testid="display-title">
                @if (!selectedOptions() || selectedOptions().length === 0) {
                    {{ 'selectorSelect.empty.title' | apContent }}
                } @else if (selectedOptions().length === 1) {
                    <span>{{ selectedOptions()[0].title }}</span>
                    @if (selectedOptions()[0].subtitle) {
                        <span
                            [class.negative-amount]="selectedOptions()[0]?.subtitle?.includes('-')"
                            class="ap-selector__subtitle"
                            data-testid="display-subtitle"
                            [innerHTML]="selectedOptions()[0].subtitle"
                        ></span>
                    }
                } @else {
                    {{ multipleTitle() | apContent }}
                }
            </span>
            <span class="ap-selector__text" data-testid="display-text">
                @if (!selectedOptions() || selectedOptions().length === 0) {
                    {{ 'selectorSelect.empty.text' | apContent }}
                } @else if (selectedOptions().length === 1) {
                    {{ selectedOptions()[0].text }}
                } @else {
                    {{
                        multipleText() | apContent: { options: options().length.toString(), selected: selectedOptions().length.toString() }
                    }}
                }
            </span>

            @if (!isDisabled) {
                <ap-icon class="ap-selector__icon" name="chevron-right" color="inherit"></ap-icon>
            }
        </span>
    </div>
</div>

@if (control) {
    <ap-form-errors data-testid="errors" [control]="control" [messages]="messages()" [attr.id]="uniqueId + '-errors'"></ap-form-errors>
}
